import styled from 'styled-components';
import React, { FC } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import FormattedReviewTerm from './FormattedReviewTerm';
import { getAssignmentColor } from '@oberoninternal/travelbase-ds/constants/theme';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import Star from '@oberoninternal/travelbase-ds/svg/Star';
import { Flex } from '@rebass/grid';

interface Props {
    value: number;
    reviewCount?: number;
}

const Rating: FC<React.PropsWithChildren<Props>> = ({ value, reviewCount }) => (
    <Container>
        <Star />
        <Body variant="small">
            <Flex>
                <FormattedNumber value={value} /> <FormattedReviewTerm average={value} />
                {reviewCount && reviewCount > 0 && (
                    <CountContainer>
                        <FormattedMessage defaultMessage="({count} Beoordelingen)" values={{ count: reviewCount }} />
                    </CountContainer>
                )}
            </Flex>
        </Body>
    </Container>
);

export default Rating;

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    color: ${({ theme }) =>
        theme.colorAssignments.rating
            ? getAssignmentColor(theme, theme.colorAssignments.rating)
            : theme.colors.secondary['30']};
    > p {
        margin-left: ${({ theme }) => theme.spacing['20_Tiny']};
        font-weight: 700;
    }
    > svg {
        margin-top: -${({ theme }) => theme.spacing['10_Micro']};
        width: 1.6rem;
    }
    margin-bottom: 0;
`;

const CountContainer = styled.div`
    margin-left: 0.8rem;
`;
